import React, { useMemo } from "react";
import { connect } from "react-redux";
import {
  mapStateToPropsCookieConsent,
  mapDispatchToPropsCookieConsent,
} from "../../../modules/cookieConsent";
import { mapDispatchToPropsLayout } from "../../../modules/layout";
import styled, { withTheme } from "styled-components";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { useTranslation } from "react-i18next";

const StyledBanner = styled.div`
  color: ${(props) => props?.theme?.black};
  font-weight: inherit;
  background: ${(props) => props?.theme?.lightGreen};
  display: flex !important;
  width: 100%;
  bottom: 0;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 3000;
  padding: 13px 10px;
  visibility: visible !important;
  orphans: 2 !important;
  overflow: auto;
  text-justify: inter-word;

  @media print {
    display: none !important;
  }

  .consent-banner-btn-container {
    display: inline-flex;
    .ultra-shadow {
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
      transition: all 0.2s ease-in-out;
    }
    .ultra-shadow:hover {
      box-shadow: 0 14px 35px rgba(0, 0, 0, 0.25);
    }
  }
  p {
    text-align: center;
    margin: 10px 20px;
    font-size: 0.9rem;
    a {
      text-decoration: none;
    }
  }
`;

const CookieBanner = (props) => {
  const { t } = useTranslation();
  const { acceptCookieFunction, isCookiesAccepted } = props;

  const closeCookieBanner = (e) => {
    e.preventDefault();
    acceptCookieFunction();
  };

  const cookiesText = useMemo(() => {
    return t("appText.landing.cookies.text", {
      cookie_policy: `<a href="https://www.ultragenyx.com/cookie-policy/" target="_blank" rel="noopener noreferrer" className="block__link small-link">${t(
        "appText.footer.cookiePolicy"
      )}</a>`,
      privacy_policy: `<a href="https://www.ultragenyx.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="block__link small-link">${t(
        "appText.footer.privacyPolicy"
      )}</a>`,
      interpolation: { escapeValue: false },
    });
  }, [t]);

  return (
    <>
      {!isCookiesAccepted && (
        <StyledBanner>
          <p
            dangerouslySetInnerHTML={{
              __html: cookiesText,
            }}
          />
          <div className="consent-banner-btn-container">
            <PrimaryButton
              className="btn btn-primary ultra-shadow btn-sm"
              onClick={closeCookieBanner}
              style={{ whiteSpace: "nowrap" }}
            >
              {t("appText.landing.cookies.cta")}
            </PrimaryButton>
          </div>
        </StyledBanner>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...mapStateToPropsCookieConsent(state),
  };
};

const mapDispatchToProps = {
  ...mapDispatchToPropsCookieConsent,
  ...mapDispatchToPropsLayout,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTheme(CookieBanner));
